module.exports = __webpack_public_path__ + "img/step_research.9549dd0e.png";